export function urlEncodeB64(str: string): string {
  // Make URL friendly
  return window
    .btoa(str)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function urlDecodeB64(str: string): string {
  // Reverse to original encoding and include base64 padding
  return window.atob(
    (str + "===".slice((str.length + 3) % 4))
      .replace(/-/g, "+")
      .replace(/_/g, "/")
  );
}

export function urlValidateB64(str: string): boolean {
  return /^[A-Za-z0-9\-_=]+$/.test(str);
}

// The following methods are from https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
// Unicode compliant base64 encoder for strings
export function urlEncodeB64Unicode(str: string) {
  return window.btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(Number("0x" + p1)); //eslint-disable-line
    })
  );
}

// Unicode compliant decoder for base64-encoded strings
export function urlDecodeB64Unicode(str: string) {
  return decodeURIComponent(
    window
      .atob(str)
      .split("")
      .map(c => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2); //eslint-disable-line
      })
      .join("")
  );
}
